(function () {
  if (!document.querySelector(".section-landing-page-base")) {
    return;
  }

  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  var widgets = Array.prototype.slice.call(document.querySelectorAll("[data-lead-widget]"));

  if (!widgets.length) {
    return;
  }

  function isShopifyCustomerForm(form) {
    return Boolean(form.querySelector("input[name='form_type'][value='customer']"));
  }

  async function submitShopifyCustomerForm(form) {
    var response = await fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      credentials: "same-origin",
      headers: {
        Accept: "text/html"
      }
    });

    if (!response.ok) {
      throw new Error("Shopify customer form request failed.");
    }
  }

  function setInvalid(form) {
    form.classList.add("is-invalid");
    var input = form.querySelector("input[type='email']");
    if (input) {
      input.setAttribute("aria-invalid", "true");
    }
  }

  function clearInvalid(form) {
    form.classList.remove("is-invalid");
    var input = form.querySelector("input[type='email']");
    if (input) {
      input.removeAttribute("aria-invalid");
    }
  }

  function showSuccessOnWidget(widget) {
    if (!widget) {
      return;
    }

    var form = widget.querySelector(".lm-lead-form");
    var success = widget.querySelector("[data-lead-success]");

    widget.classList.add("is-success");

    if (form) {
      clearInvalid(form);
      form.hidden = true;
      form.setAttribute("aria-hidden", "true");
    }

    if (success) {
      success.hidden = false;
      success.removeAttribute("aria-hidden");
    }
  }

  function showSuccessEverywhere() {
    widgets.forEach(showSuccessOnWidget);
  }

  widgets.forEach(function (widget) {
    if (widget.classList.contains("is-success") || widget.hasAttribute("data-lead-subscribed")) {
      showSuccessOnWidget(widget);
    }
  });

  var forms = widgets
    .map(function (widget) {
      return widget.querySelector(".lm-lead-form");
    })
    .filter(function (form) {
      return form && !form.hidden && form.querySelector("input[type='email']");
    });

  forms.forEach(function (form) {
    var input = form.querySelector("input[type='email']");
    if (!input) {
      return;
    }

    input.addEventListener("input", function () {
      if (form.classList.contains("is-invalid")) {
        clearInvalid(form);
      }
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      var value = input.value.trim();
      var button = form.querySelector("button[type='submit']");

      if (!emailPattern.test(value)) {
        setInvalid(form);
        input.focus();
        return;
      }

      if (!isShopifyCustomerForm(form)) {
        showSuccessEverywhere();
        return;
      }

      if (button) {
        button.disabled = true;
      }

      submitShopifyCustomerForm(form)
        .then(function () {
          showSuccessEverywhere();
        })
        .catch(function () {
          if (button) {
            button.disabled = false;
          }
          setInvalid(form);
          input.focus();
        });
    });
  });
})();
